import type {
  IHeroFields,
  IImageFields,
  IMotionFields,
  IVideoFields,
} from 'types/generated/contentful';
import type { CommonHeroT, FullHeroT } from 'src/ui/hero/Hero';
import type { MotionT } from 'src/ui/Motion';
import { getDynamicContentfulHeading } from './getDynamicContentfulHeading';
import { getDynamicContentfulSubheading } from './getDynamicContentfulSubheading';
import { getDynamicContentfulReferenceActions } from './getDynamicContentfulReferenceActions';
import { getContentfulImageProps } from './getContentfulImageProps';

const getMotionProps = (motion: IMotionFields): MotionT => ({
  src: motion.motionUrl || motion.motion.fields.file.url,
  posterSrc: motion.poster?.fields?.file.url,
});

export function getDynamicContentfulHero({
  hasUser,
  hero,
}: {
  hasUser: boolean;
  hero: IHeroFields | null;
}): CommonHeroT | FullHeroT {
  return {
    badge: hero?.badge?.fields.text,
    heading: getDynamicContentfulHeading({
      hasUser,
      value: hero?.heading?.fields ?? null,
    }),
    subheading: getDynamicContentfulSubheading({
      hasUser,
      value: hero?.subheading?.fields ?? null,
    }),
    actions: getDynamicContentfulReferenceActions({
      hasUser,
      value: hero?.actions?.fields ?? null,
    }),
    image: (hero?.image?.fields as IImageFields)?.image?.fields.file
      ? getContentfulImageProps(hero?.image?.fields as IImageFields)
      : undefined,
    motion: (hero?.image?.fields as IMotionFields)?.motion?.fields.file
      ? getMotionProps(hero?.image?.fields as IMotionFields)
      : undefined,
    video: (hero?.image?.fields as IVideoFields)?.url
      ? (hero?.image?.fields as IVideoFields)
      : undefined,
    layout: hero?.layout,
    invertLayout: hero?.invertLayout,
    imageMaxWidth: hero?.imageMaxWidth,
    theme: hero?.mood?.fields.colors
      ? { colors: hero?.mood?.fields.colors }
      : undefined,
  };
}
